// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"688":"same-radical-words","826":"index"}[chunkId] + "-legacy." + {"688":"2d346a02","826":"1f9cdf9e"}[chunkId] + ".js";
};